import { StageTools } from '../types';

export const PROBLEM_DEFINITION_TOOLS: StageTools = [
  {
    category: "用户调研",
    tools: [
      {
        name: "问卷星",
        icon: "",
        description: "免费问卷调查工具，帮助收集用户反馈",
        url: "https://www.wjx.cn",
        tags: ["问卷调查", "用户研究"]
      },
      {
        name: "腾讯问卷",
        icon: "",
        description: "专业的问卷调查平台，支持多种题型",
        url: "https://wj.qq.com",
        tags: ["问卷调查", "数据分析"]
      }
    ]
  },
  {
    category: "竞品分析",
    tools: [
      {
        name: "SimilarWeb",
        icon: "",
        description: "网站流量分析和竞争情报工具",
        url: "https://www.similarweb.com",
        tags: ["竞品分析", "市场研究"]
      },
      {
        name: "AppAnnie",
        icon: "",
        description: "移动应用市场数据分析平台",
        url: "https://www.appannie.com",
        tags: ["应用分析", "市场数据"]
      }
    ]
  },
  {
    category: "需求管理",
    tools: [
      {
        name: "Notion",
        icon: "",
        description: "多功能协作平台，适合整理需求文档",
        url: "https://www.notion.so",
        tags: ["文档管理", "协作"]
      },
      {
        name: "飞书文档",
        icon: "",
        description: "在线协作文档工具，支持多人实时编辑",
        url: "https://www.feishu.cn",
        tags: ["文档协作", "团队协作"]
      }
    ]
  }
]; 